import { useEffect } from 'react';
import { api } from '@/api/client';
import { forgetGuestKey, readGuestKey } from './guest-key';

/** After a visitor signs up or in, what they tried in the taster becomes part of their account. */
export function useClaimTaster(signedIn: boolean): void {
  useEffect(() => {
    if (!signedIn) return;
    const key = readGuestKey();
    if (!key) return;
    void api
      .post('/api/v1/me/taster/claim', { body: { guestKey: key } })
      .then(forgetGuestKey)
      .catch(() => undefined);
  }, [signedIn]);
}
